var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VWrapper',{attrs:{"title":"lightspeed.success"}},[_vm._v(" "+_vm._s(_vm.$t('lightspeed.successDescription'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }